import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues, change } from 'redux-form';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import _ from 'lodash';
import agent from '../agent'

import validate from './registration/validate';

import ArrayCheckbox from "./ArrayCheckbox";
import NewAgency from './NewAgency';
import AMLogo from '../assets/images/Default Agency Logo.png';

import SelectComponent from './ui/SelectComponent'


const renderRepresentation = ({ input, onChange, meta: { touched, error } }) => (
  <div>
    <select {...input} selected={onChange} >
		<option value="">My Representation</option>
        <option value="freelance">Freelance</option>
	    <option value="represented">Represented</option>
    </select>
    { (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
  </div>
)

const renderSearchAgency = ({ input, className, placeholder, type, meta: { touched, error } }) => (
  	<div>
		<input {...input} placeholder={placeholder} type={type} />
		{ (touched && error) && <span className="form-error is-visible" id="uuid">{error}</span> }
	</div>
)


class RepresentationForm extends Component {
	state = {
		searchTerm: '',
		searchTimeout: {},
		isNewAgency: false,
		searchingAgency: false
	}

	searchAgency = _.debounce( event => {
		if (event.target.value.length < 3) { return false }
		this.props.searchAgency(event.target.value, this.props.hasCountry);
	}, 1000)

	componentWillMount() {
		console.log('componentWillMount-represent', this.props)
		if (this.props.hidRepresent)
			this.props.submit();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.agency) {			
			this.props.change('artist[company_id]', nextProps.agency.id)
			this.props.change('agency', nextProps.agency)
			this.props.onSubmit(this.props.handleSubmit)
		}
	}

	onChangeRepresentation = (stateType, event, newValue) => {
		console.log('csd', stateType, event, newValue);

		if (newValue !== 'represented') {
			this.props.change('searchAgency', "")
			this.props.change('agency', "")
			this.props.change('artist[company_id]', "")
			this.setState({isNewAgency: false})
			this.props.clearAgencies()
		}
	
    }

	newAgency = (e) => {
		e.preventDefault();
		this.props.change('artist[company_id]', "")
		this.setState({isNewAgency: true});
	}

	onKeyPress = (event) => {
	    if (event.key === 13 /* Enter */) {
	      event.preventDefault();
	    }
	}

	addDefaultSrc = (ev) => {
		console.log('Invoked missing image', ev.target.src)
	  ev.target.src = AMLogo
	}

	submit = (values, dispatch, props) => {
		console.log('representation', props);

		if (values.representation === 'freelance') { props.submit() }
		if (values.representation === 'represented' && values.artist && values.artist.company_id) {
			props.onSubmit(props.handleSubmit);
			return
		}
		if (values.representation === 'represented' && values.agency) {
			// console.log('submit agency', values.agency);

			values.agency.email = values.agency.agent_email_address
			values.agency.contact_number = values.agency.agent_contact_number
			values.agency.website = ""

			var params = {
				agency: values.agency,
				artist_name: `${values.artist.first_name} ${values.artist.last_name}`,
				project_name: props.project.name, 
				company_name: props.client.canonical_name
			}

			console.log('registerAgency', params)

			// this.props.registerAgency(params)
			props.registerAgency(params)
		}
	}

  render() {
		const { handleSubmit, previousPage, representation, agencies = [], hidRepresent, location, project } = this.props
		
		return (
		<form onSubmit={handleSubmit(this.submit)} className="registartion-representation-form" id="reg-representation-form" >

			<section className="section gray-bg">
				<div className="grid-x align-center">
				<div className="small-12 medium-10 large-8 cell">

					<div className="row">
						<div className="small-12 medium-8 medium-centered column">
							<Field 
								name="representation" 
								onChange={this.onChangeRepresentation.bind(this, "representation")}
								component={SelectComponent}
								validate={[value => !value && "Representation is required"]}
								placeholder="Please select representation"
								options={[{value: 'freelance', label: "Freelance"}, {value: 'represented', label: "Represented"}]} />
						</div>
					</div>
					
					{representation === 'represented' && (
						<div className="row">
							<div className="small-12 medium-8 medium-centered column">
								<Field 
									name="searchAgency"
									component={renderSearchAgency}
									type="text"
									onChange={this.searchAgency}
									hasCountry={this.props.hasCountry}
									validate={[value => !value && "Please enter name of your agency"]}
									onKeyPress={this.onKeyPress}
									placeholder="Type agency / manager name and press enter"/>
							</div>
						</div>
					)}

					<div>

						{!this.state.isNewAgency && representation === 'represented' && (
				            agencies.map( agency => {
				              return (
				                <div className="row representation-agency-list" key={agency.id}>
				                <div className="small-12 medium-8 medium-centered column">
				                <div className="row">
									<div className="small-3 column text-left">
										<img onError={this.addDefaultSrc} src={agency.logo_url || AMLogo} alt="" />	
									</div>
									<div className="small-6 column text-left">
										<div className="agency-name">{agency.name}</div>
									    <div className="agency-location">{agency.state_name}, {agency.country}</div>
									</div>
									<div className="small-3 column">
										<Field 
											name="artist[company_id]"
											itemValue={agency.id}
											component={ArrayCheckbox}
											/>
									</div>
								</div>
								</div>
								</div>
				              )
				            })
				        )}

				        {representation === 'represented' && agencies.length > 0
				         	? 	<div className="row">
									<div className="samll-12 column">
									<p className="text-center">My agency/ management is not listed 
									<a className="primary" onClick={this.newAgency}> Click here</a></p>
									</div>
								</div>
							: ''
				        }

						
				        {this.state.isNewAgency && representation == 'represented'   && (<NewAgency />)}

					</div>
			
				</div>
				</div>
			</section>

			<section className="section registration-action-buttons">
				<div className="grid-x align-center">
					<div className="small-12 cell text-center">
						<button className="button primary next" type="submit">Next</button>
					</div>
				</div>
			</section>
		</form>
  		)
	}	
}

RepresentationForm = reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(RepresentationForm)

const selector = formValueSelector('artistRegistrationWizard')
const mapStateToProps = state => ({
	agency: state.artist.agency,
  agencies: state.artist.agencies,
  representation: selector(state, 'representation'),
  registrationValues: getFormValues('artistRegistrationWizard')(state),
  hasCountry: selector(state, 'artist[country]'),
});

const mapDispatchToProps = dispatch => ({
  registerAgency: agency => 
  	dispatch({ type: 'REGISTER_AGENCY', payload: agent.Agency.register(agency) }),
  searchAgency: (search, country) => 
  	dispatch({ type: 'SEARCH_AGENCY', payload: agent.Agency.search(search, country) }),
  clearAgencies: () => dispatch({type: 'CLEAR_AGENCIES'}),
  fieldChange: (type, value) => 
  	dispatch(change('artistRegistrationWizard', type, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(RepresentationForm);


// WEBPACK FOOTER //
// ./src/components/RepresentationForm.js